import axios from "axios";
const API_BASE_URL = '/callcenter';

export const apiUrl =  (process.env.REACT_APP_API_URL !== undefined) ? process.env.REACT_APP_API_URL : 'https://staging.alliance-crm.com' 
// export const apiUrl = 'https://erp.apollosoft.co';

let token = localStorage.getItem('CRM_TOKEN')
let headers

if(token !== null){
    headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+ token
    }
}else{
    headers = { 'Content-Type': 'application/json' }
}

export default axios.create({
    baseURL: apiUrl+API_BASE_URL,
    responseType: "json",
    headers: headers
});